/**
 * DBS-350: noticing that a newer build of the portal is live, so a tab left open across a deploy can offer a reload.
 * scripts/build.sh writes the build's release to version.json, served with Cache-Control: no-cache.
 */
export const VERSION_URL = '/version.json'
export const CHECK_INTERVAL_MS = 10 * 60 * 1000

/** The release live on the site now, or undefined when it can't be read (offline, or no version.json yet) */
export const fetchLiveRelease = async (fetchFn: typeof fetch = fetch): Promise<string | undefined> => {
  try {
    const response = await fetchFn(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return undefined
    const body = await response.json()
    return typeof body?.release === 'string' ? body.release : undefined
  } catch {
    return undefined
  }
}

/** A different build is live; never under npm start, which has no release */
export const isNewBuildLive = (current: string, live: string | undefined): boolean =>
  current !== 'development' && live !== undefined && live !== current
